import { lifecycle, compose } from "recompose";
import { withCookies } from "react-cookie";
import { graphql } from "react-apollo";
import HeaderQuery from "theme/layouts/Header/HeaderQuery.gql";

const withCustomerDatalayer = compose(
  graphql(HeaderQuery, {
    props: ({ data }) => ({
      customer: data.me,
    }),
  }),
  withCookies,
  lifecycle({
    componentDidMount: function () {
      const customer = this.props.customer;

      let Customer = {
        user: {
          logged: customer?.id ? "1" : "0",
          userId: customer?.encodedEmail ?? "",
        },
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Customer);
    },
    componentDidUpdate: function () {
      const customer = this.props.customer;

      let Customer = {
        user: {
          logged: customer?.id ? "1" : "0",
          userId: customer?.encodedEmail ?? "",
        },
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Customer);
    },
  })
);

export default withCustomerDatalayer;
